import React, {Component} from 'react';
import {connect} from 'react-redux';
import GetHelpNow from '../../Shared/GetHelpNow';
import './css/PlanningPage.styl';

export class FuneralPlanning extends Component {
  static propTypes = {
    funeralHome: React.PropTypes.object.isRequired,
  };

  render() {
    const {name} = this.props.funeralHome;

    return (
      <section className="fh-planning">
        <GetHelpNow />
        <div className="funeral-home-planning">
          <header className="benefits-of-pre-planning__header">
            Whether it’s time — or ahead of time
          </header>
          <p className="benefits-of-pre-planning__text">
            Pre-planning your funeral can be one of the biggest gifts you give
            to your loved ones. Grief can be confusing and overwhelming. Taking
            care of your own arrangements can lift a burden off your family
            during such an emotional time.
          </p>
          <p className="benefits-of-pre-planning__text">
            As one of Legacy’s funeral home partners, {name} is intimately
            familiar with the major decisions a family has to make.
          </p>
          <p className="benefits-of-pre-planning__text">
            Those range from the practical (what kind of burial and where?) and
            the personal (who will provide comfort and support?) to the
            financial (is pre-payment a good idea?) and the legal (what
            documents are required?).
          </p>
          <p className="benefits-of-pre-planning__text">
            {name} is here to help you and your family with your pre-planning
            needs. Contact {name} when you’re ready to discuss a free,
            customized funeral plan.
          </p>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  funeralHome: state.funeralHomeStore,
});

export default connect(mapStateToProps)(FuneralPlanning);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/FuneralPlanning/index.js